<template>
  <div class="index">
    <mu-paper :z-depth="3" class="left">
      <mu-paper class="info" :z-depth="3">
        <mu-avatar :size="80">
          <img :src="user.headimgurl || 'static/img/admin/avatar.jpg'" />
        </mu-avatar>
        <div class="nick-name">{{ user.realName }}</div>
        <div class="group-name">
          <div class="label" v-if="user.role">{{ user.role.name }}</div>
          <mu-menu cover placement="bottom-start" :open.sync="menuOpen">
            <mu-button icon>
              <mu-icon value="more_vert"></mu-icon>
            </mu-button>
            <mu-list slot="content">
              <mu-list-item button @click="profile">
                <mu-list-item-title>个人资料</mu-list-item-title>
              </mu-list-item>
              <mu-list-item button @click="password">
                <mu-list-item-title>修改密码</mu-list-item-title>
              </mu-list-item>
              <mu-list-item button @click="logout">
                <mu-list-item-title>注销</mu-list-item-title>
              </mu-list-item>
              <mu-list-item button @click="setLocalFilePath">
                <mu-list-item-title>设置本地文件路径</mu-list-item-title>
              </mu-list-item>
              <mu-list-item button @click="setLocalFilePath2">
                <mu-list-item-title>设置本地文件路径2</mu-list-item-title>
              </mu-list-item>
            </mu-list>
          </mu-menu>
        </div>
      </mu-paper>
      <mu-list toggle-nested class="menu">
        <mu-list-item
          button
          nested
          :open="open === item.id"
          @toggle-nested="open = arguments[0] ? item.id : 0"
          v-for="(item, index) in menuTreeLocal
            .filter((x) => x.isMenu)
            .sort((a, b) => (a.sort - b.sort >= 0 ? 1 : -1))"
          :key="index"
        >
          <mu-list-item-action>
            <mu-icon :value="item.icon"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>{{ item.name }}</mu-list-item-title>
          <mu-list-item-action>
            <mu-icon
              class="toggle-icon"
              size="24"
              value="keyboard_arrow_down"
            ></mu-icon>
          </mu-list-item-action>
          <template
            v-for="(sub, subIndex) in item.children.sort((a, b) =>
              a.sort - b.sort >= 0 ? 1 : -1
            )"
          >
            <mu-list-item
              button
              slot="nested"
              @click="menuClick(sub)"
              :class="{ active: sub.name === $route.name }"
              :key="subIndex"
              :to="sub.link"
              v-if="user.role.menus.some((x) => x.id === sub.id) && sub.isMenu"
            >
              <mu-list-item-title>{{ sub.name }}</mu-list-item-title>
            </mu-list-item>
          </template>
        </mu-list-item>
      </mu-list>
    </mu-paper>
    <div class="right">
      <mu-ripple class="button left-button" @click.native="leftClick">
        <mu-icon value="arrow_back_ios"></mu-icon>
      </mu-ripple>
      <mu-ripple class="button right-button" @click.native="rightClick">
        <mu-icon value="arrow_forward_ios"></mu-icon>
      </mu-ripple>
      <mu-ripple class="button refresh-button" @click.native="refresh">
        <mu-icon value="autorenew"></mu-icon>
        <div class="label">刷新</div>
      </mu-ripple>
      <div class="nav" ref="nav">
        <div class="nav-wrapper" ref="navWrapper">
          <div
            :class="['nav-item', { active: item.active }]"
            v-for="(item, index) in navList"
            :key="index"
            ref="navItem"
            @click="navClick(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <keep-alive>
        <router-view class="router-view" ref="routerView"></router-view>
      </keep-alive>
    </div>
    <Profile :open.sync="profileOpen" :form="user"></Profile>
    <Password :open.sync="passwordOpen"></Password>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import { mapGetters } from 'vuex'
import session from 'utils/session'
import backend from 'utils/backend'
import api from '@/api'
import Profile from './profile'
import Password from './password'
import Message from 'muse-ui-message'
export default {
  components: { Profile, Password },
  data() {
    return {
      open: '',
      menuOpen: false,
      scroll: null,
      leftScrollCount: 0,
      navList: [
        {
          active: true,
          name: '首页',
          url: '/',
          id: 113
        }
      ],
      profileOpen: false,
      passwordOpen: false
    }
  },
  methods: {
    menuClick(sub) {
      this.navList.forEach((item) => {
        item.active = false
      })
      let exist = this.navList.find((x) => x.id === sub.id)
      if (exist) {
        exist.active = true
      } else {
        sub.active = true
        this.navList.push(sub)
      }
      this.$router.replace(sub.url)
    },
    navClick(item) {
      this.navList.forEach((item) => {
        item.active = false
      })
      item.active = true
      this.$router.replace(item.url)
    },
    setScroll() {
      this.$refs.nav.style.width = window.innerWidth - 220 - 92 - 92 + 'px'
    },
    leftClick() {
      if (this.$refs.navWrapper.clientWidth > this.$refs.nav.clientWidth - 92) {
        let width = this.$refs.navItem[this.leftScrollCount].offsetWidth
        this.scroll.scrollBy(-1 * width, 0, 1000)
        this.leftScrollCount++
      }
    },
    rightClick() {
      this.scroll.scrollTo(0, 0, 1000)
      this.leftScrollCount = 0
    },
    logout() {
      session.removeSession('user')
      backend(api.auth.logout).then(() => {
        this.$router.replace('/login')
      })
    },
    navInit() {
      let nav = this.user.role.menus.find((x) => x.url === this.$route.path)
      this.menuClick(nav)
    },
    refresh() {
      if (this.$refs.routerView.getAll) {
        this.$refs.routerView.getAll()
      }
    },
    profile() {
      this.profileOpen = true
    },
    password() {
      this.passwordOpen = true
    },
    setLocalFilePath() {
      Message.prompt('请输入本地文件路径', '本地文件路径').then(
        ({ result, value }) => {
          if (result) {
            localStorage.setItem('local-path', value)
            this.$toast.success('设置成功')
          }
        }
      )
    },
    setLocalFilePath2() {
      Message.prompt('请输入本地文件路径', '本地文件路径').then(
        ({ result, value }) => {
          if (result) {
            localStorage.setItem('local-path2', value)
            this.$toast.success('设置成功')
          }
        }
      )
    }
  },
  computed: {
    ...mapGetters(['user', 'menuTree', 'menuClickInOtherPage']),
    menuTreeLocal() {
      return JSON.parse(JSON.stringify(this.menuTree))
    }
  },
  mounted() {
    this.setScroll()
    window.onresize = () => {
      this.setScroll()
    }
    this.navInit()
    this.scroll = new BScroll(this.$refs.nav, {
      scrollX: true,
      scrollY: false,
      click: false,
      momentum: false,
      snap: true,
      snapThreshold: 0,
      snapSpeed: 400,
      scrollbar: false,
      probeType: 1
    })
  },
  watch: {
    menuClickInOtherPage(nav) {
      this.menuClick(nav)
    }
  }
}
</script>

<style lang="less" scoped>
.index {
  display: flex;
  width: 100%;
  height: 100%;
  .left {
    flex: 0 0 220px;
    .info {
      height: 220px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #2196f3;
      color: #fff;
      .nick-name {
      }
      .group-name {
        display: flex;
        .label {
          line-height: 48px;
          height: 48px;
        }
      }
    }
    .menu {
      padding: 0;
      .toggle-icon {
        transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
      }
      .mu-item__open {
        .toggle-icon {
          transform: rotate(180deg);
        }
      }
      .active {
        .mu-item-title {
          color: #2196f3;
        }
      }
    }
  }
  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 0;
    .button {
      position: absolute;
      width: 46px;
      height: 46px;
      text-align: center;
      top: 0;
      cursor: pointer;
      box-sizing: border-box;
      z-index: 9;
      background-color: #4caf50;
      user-select: none;
      i {
        line-height: 46px;
        position: relative;
        color: #fff;
      }
      &.left-button {
        left: 0;
        i {
          left: 4px;
        }
      }
      &.right-button {
        right: 92px;
        i {
          left: 2px;
        }
      }
      &.refresh-button {
        right: 0;
        width: 92px;
        background: #f44336;
        .label {
          display: inline-block;
          font-size: 20px;
          line-height: 46px;
          color: #fff;
          vertical-align: top;
        }
      }
    }
    .nav {
      flex: 0 0 46px;
      position: relative;
      border-bottom: 1px solid #1565c0;
      box-sizing: border-box;
      overflow: hidden;
      margin-left: 46px;
      .nav-wrapper {
        white-space: nowrap;
        display: inline-block;
        .nav-item {
          display: inline-block;
          height: 46px;
          line-height: 46px;
          cursor: pointer;
          padding: 0 18px;
          border: 1px solid #ddd;
          box-sizing: border-box;
          font-size: 16px;
          &.active {
            color: #fff;
            background-color: #1565c0;
            border: 1px solid #1565c0;
          }
        }
      }
    }
    .router-view {
      padding: 30px;
      flex: 1;
      overflow-y: auto;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/index.vue